import { LibSubContractorsDto  } from "@gtpl/shared-models/gtpl";
import { GlobalResponseObject } from '@gtpl/shared-models/common-models';


export class AllSubContractorsResponseModel extends GlobalResponseObject {
    data?: LibSubContractorsDto[];
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: LibSubContractorsDto[]){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}

